import classNames from 'classnames';
import Image      from 'next/image';
import Link       from 'next/link';

export default function ArticleSummary({
	                                       article,
	                                       authors,
	                                       category,
	                                       featured,
	                                       className,
                                       }) {
	const ogImageQueryParameters = [
		{
			key:   'title',
			value: article.title,
		},
	]
		.filter((item) => item);

	const encodeQueryParameters = (parameters) => {
		return parameters.map((parameter) => {
			return `${parameter.key}=${encodeURIComponent(parameter.value)}`;
		})
		                 .join('&');
	};

	const ogImageUrl = `https://atlas.dev/api/article-summary?${encodeQueryParameters(ogImageQueryParameters)}`;

	return (<article className={className}>
		<div className={classNames([
			'h-full relative isolate flex flex-col lg:gap-4 shadow-xl overflow-hidden rounded-2xl group',
		])}
		>
			<div className={classNames([
				'relative shrink-0 aspect-[16/9] bg-white rounded-t-2xl overflow-hidden',
			])}
			>
				<Link href={`/blog/${article.slug}`}
				      tabIndex={-1}
				>
					<Image className={classNames([
						'absolute inset-0 h-full w-full opacity-90 hover:opacity-100 overflow-hidden object-cover',
					])}
					       src={article.image ?? ogImageUrl}
					       width={2400}
					       height={1350}
					       alt={article.title}
					       priority={featured}
					/>

					<div className="absolute inset-0 rounded-2xl" />
				</Link>
			</div>

			<div className={classNames([
				'mt-4 lg:mt-0 w-full h-full',
			])}
			>
				<Link href={`/blog/${article.slug}`}
				      className={classNames([
					      'relative w-full px-4 pb-2 h-full flex flex-col justify-between',
				      ])}
				>
					<span className="absolute inset-0" />

					<div className="flex-1 h-full relative space-y-1">
						<h3 className={classNames([
							'text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600',
						])}
						>
							{article.title}
						</h3>

						<p className={classNames([
							'line-clamp-3 text-sm leading-6 text-gray-600',
						])}
						>{article.description}</p>
					</div>

					<div className={classNames([
						'flex-shrink-0 flex justify-between items-center gap-x-4 mt-8',
					])}
					>
						<div className="relative flex items-center gap-x-4">
							<div className="flex -space-x-2 overflow-hidden flex-shrink-0">
								{authors.map((author, index) => {
									return (<Image
										key={index}
										className="inline-block h-10 w-10 rounded-full ring-2 ring-white grayscale group-hover:grayscale-0 group-focus:grayscale-0"
										src={author.avatar}
										width={40}
										height={40}
										alt={author.name}
									/>);
								})}
							</div>

							{authors.length === 1 && <div className="text-sm leading-6">
								<p className="font-semibold text-gray-900">
									<span className="absolute inset-0" />
									{authors[0].name}
								</p>

								<p className="text-gray-500 group-hover:text-teal-700">{authors[0].role}</p>
							</div>}

							{authors.length > 1 && <div className="text-sm leading-6">
								<p className="font-semibold text-gray-900">
									<span className="absolute inset-0" />

									{authors.slice(0, -1)
									        .map((author) => {
										        return author.name;
									        })
									        .join(', ')}
									{` & ${authors[authors.length - 1].name}`}
								</p>
							</div>}
						</div>

						<div className="flex-shrink-0 space-y-1 flex flex-col items-end text-sm">
							<span className="font-medium text-teal-600 text-sm">
								{category.name}
							</span>

							<time dateTime={article.datetime}
							      title={article.datetime}
							      className="text-gray-500 group-hover:text-teal-700"
							>
								{article.date}
							</time>
						</div>
					</div>
				</Link>
			</div>
		</div>
	</article>);
}
